module.exports = __webpack_public_path__ + "static/media/Sansa Stark.84aed1b4.jpg";